import { SITE_URL, DEFAULT_IMAGE, LOGO_IMAGE, SITE_NAME } from './siteConfig';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: SITE_NAME,
      headline: SITE_NAME,
      description:
        'Yakis Transporte Empresarial - Más de 20 años de experiencia en transporte de personal industrial y empresarial en San Luis Potosí y Monterrey. Seguridad, puntualidad y calidad garantizadas.',
      datePublished: '2004-01-01',
      dateModified: '2026-05-27',
      inLanguage: 'es-MX',
      isPartOf: {
        '@id': `${SITE_URL}/#organization`,
      },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: DEFAULT_IMAGE,
        width: 1200,
        height: 630,
      },
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#organization`,
      name: SITE_NAME,
      alternateName: 'Yakis',
      description:
        'Yakis Transporte Empresarial - Más de 20 años de experiencia en transporte de personal industrial y empresarial en San Luis Potosí y Monterrey. Seguridad, puntualidad y calidad garantizadas.',
      url: `${SITE_URL}/`,
      telephone: '+52-444-195-1948',
      email: 'ventas@yakis.com.mx',
      image: DEFAULT_IMAGE,
      logo: {
        '@type': 'ImageObject',
        url: LOGO_IMAGE,
        width: 512,
        height: 512,
      },
      foundingDate: '2004',
      priceRange: '$$',
      address: [
        {
          '@type': 'PostalAddress',
          addressLocality: 'San Luis Potosí',
          addressRegion: 'SLP',
          addressCountry: 'MX',
        },
        {
          '@type': 'PostalAddress',
          addressLocality: 'Monterrey',
          addressRegion: 'NL',
          addressCountry: 'MX',
        },
      ],
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '22.1565',
        longitude: '-100.9855',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+52-444-195-1948',
          contactType: 'sales',
          areaServed: ['MX-SLP', 'MX-NL'],
          availableLanguage: ['Spanish'],
        },
        {
          '@type': 'ContactPoint',
          telephone: '+52-444-195-1948',
          contactType: 'customer service',
          areaServed: ['MX-SLP', 'MX-NL'],
          availableLanguage: ['Spanish'],
        },
      ],
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        opens: '00:00',
        closes: '23:59',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Transporte Empresarial',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Transporte Empresarial',
              description:
                'Soluciones de movilidad personalizadas para ejecutivos y colaboradores con flota de autobuses ejecutivos.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Transporte de Personal Industrial',
              description:
                'Movilidad segura y eficiente para plantas manufactureras y centros de distribución.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Turismo y Renta de Unidades',
              description:
                'Autobuses y camionetas modernas para viajes de turismo y eventos corporativos.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Rutas Especiales',
              description:
                'Diseño de rutas personalizadas con análisis de tráfico y optimización de tiempos.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Servicios Nocturnos',
              description:
                'Transporte seguro durante turnos nocturnos con monitoreo constante.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Turnos Mixtos',
              description:
                'Soluciones adaptadas a empresas con múltiples turnos de trabajo.',
            },
          },
        ],
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '47',
        bestRating: '5',
        worstRating: '1',
      },
      sameAs: ['https://wa.me/524441951948'],
    },
  ],
};

/**
 * Returns the Schema.org JSON-LD payload for a route, or null when the page
 * type is not eligible / required facts are unavailable.
 */
export const getSchemaForPath = (pathname: string): object | null => {
  if (pathname === '/') {
    return HOME_SCHEMA;
  }
  return null;
};